<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'系统配置'},{name:'字典配置'}]" :title="'字典配置'"/> -->
            <!-- 主内容 -->
            <div class="box">
                <ul class="leftBox">
                    <li :class="tab==index?'active':''" @click="changeTab(index,item.dictName,item.id)" :key="index" v-for="(item,index) in leftList">{{item.dictName}}</li>
                </ul>
                <div class="rightBox" v-if="!editType">
                    <!-- 内容 -->
                    <div class="retrieve" ref="condition">
                        <!-- <div class="left">
                            <div class="child">
                                <span class="name">{{tabText}}</span>
                            </div>
                        </div> -->
                        <div class="right" style="margin-top:0;">
                            <el-button type="primary" size="small" 
							@click="edit()"
							v-if="authorities.indexOf('sys:permission:background:dict:config:list:button:add')!=-1"
							>添加</el-button>
                        </div>
                    </div>
                    <!-- 表格 -->
                    <el-table
                        :data="tableData"
                        ref="table"
                        fit
                        :height="bHeight"
                        :header-cell-style="headerStyle"
                        v-loading="loading"
                element-loading-text="请求中......"
                        style="width:100%">
                        <el-table-column
						    v-if="authorities.indexOf('sys:permission:background:dict:config:list:button:sort')!=-1"
                            prop="name"
                            show-overflow-tooltip
                            >
                            <template slot-scope="scope">
                                <div class="elrow">
                                    <i class="el-icon-top" @click="moveTop(scope.row)" v-show="scope.$index!=0 || (scope.$index === 0 && sendInfoOne.currentPage  !== 1)"></i>
                                    <i class="el-icon-bottom" @click="moveDown(scope.row)" v-show="scope.$index!=tableData.length-1 || sendInfoOne.currentPage < totalPage"></i>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="sort"
                            show-overflow-tooltip
                            
                            label="排序">
                        </el-table-column>
                        <el-table-column
                            prop="dictName"
                            show-overflow-tooltip
                            
                            label="选项名称">
                        </el-table-column>
                        <el-table-column
                            prop="statusName"
                            show-overflow-tooltip
                            
                            label="状态">
                        </el-table-column>
                        <el-table-column
                            v-if="authorities.indexOf('sys:permission:background:dict:config:list:button:edit')!=-1 ||
                            authorities.indexOf('sys:permission:background:dict:config:list:button:status')!=-1"
                            label="操作"
                            
                            width="250">
                            <template slot-scope="scope">
                                <el-button 	size="small" type="primary" class="super" plain
								@click="edit(scope.row)" 
								v-if="authorities.indexOf('sys:permission:background:dict:config:list:button:edit')!=-1"
								>编辑</el-button>
                                <el-button 	size="small"  :type="scope.row.statusButtonName === '启用'?'success':'warning'"  class="super" plain
								@click="sold(scope.row)" 
								v-if="authorities.indexOf('sys:permission:background:dict:config:list:button:status')!=-1"
								>{{scope.row.statusButtonName}}</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 分页 -->
                    <div class="pagination" ref="pagination">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="sendInfoOne.currentPage"
                            :page-sizes="[5, 10, 15, 20]"
                            :page-size="sendInfoOne.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalSize">
                        </el-pagination>
                    </div>
                    <!-- 添加和编辑 -->
                    <el-dialog
                        :title="dialogEditTitle"
                        :visible.sync="dialogEdit"
                        :before-close="cancel"
                        :close-on-click-modal="false"
                        width="30%">
                        <div class="forms">
                            <div class="child">
                                <div class="name"><span>*</span>选项名称：</div>
                                <el-input v-model="sendInfo.dictName" maxlength="20"></el-input>
                            </div>
                            <div class="error" v-if="errors['sendInfo.dictName']">错误提示：{{errors['sendInfo.dictName']}}</div>

                            <div class="child">
                                <div class="name"><span>*</span>状态：</div>
                                <el-select v-model="sendInfo.status" placeholder="请选择">
                                    <el-option
                                    v-for="item in statusList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="error" v-if="errors['sendInfo.status']">错误提示：{{errors['sendInfo.status']}}</div>

                            <div class="doubleBtn">
                                <el-button type="primary" @click="cancel">取消</el-button>
                                <el-button type="primary" @click="submit">确认</el-button>
                            </div>
                        </div>
                    </el-dialog>
                </div>
                <div class="rightBox" v-else>
                    <div class="forms">
                            <div class="child">
                                <div class="name"><span>*</span>选项名称：</div>
                                <div class="content"><el-input v-model="sendInfo.dictName" maxlength="20"></el-input></div>
                            </div>
                            <div class="error" v-if="errors['sendInfo.dictName']">错误提示：{{errors['sendInfo.dictName']}}</div>

                            <div class="child">
                                <div class="name"><span>*</span>状态：</div>
                                <div class="content">
                                   <el-select v-model="sendInfo.status" placeholder="请选择">
                                    <el-option
                                    v-for="item in statusList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                </div>
                                
                            </div>
                            <div class="error" v-if="errors['sendInfo.status']">错误提示：{{errors['sendInfo.status']}}</div>
                            <div class="child">
                                <div class="name"></div>
                                <div class="content">
                                  <div class="doubleBtn">
                                      <el-button size="small" type="primary" @click="submit">确认</el-button>
                                      <el-button size="small" @click="cancel">取消</el-button>
                                  </div>
                                </div>
                            </div>
                            
                        </div>
                </div>
            </div>
        </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
import {mapState} from 'vuex'
export default {
    components:{
        // breadcrumb
    },
    data(){
        return{
          loading:false,
          bHeight: void 0,
			authorities:JSON.parse(window.localStorage.getItem('authorities')),
            tab:0,//选项卡
            tabText:'',//标题名
            statusList:[],//添加编辑状态数组
            leftList:[],//左边父级数组
            sendInfoOne:{
                parentId:null,//父id
                currentPage:1,//当前页
                pageSize:10,//当前页条数
                property:'sort',//排序字段
                direction:'asc',//排序方式
            },
            tableData:[],//表格数据
            totalSize:0,//总条数
            totalPage:0,
            dialogEdit:false,//编辑弹出层
            sendInfo:{
                parentId:'',//父级id
                id:'',//自身id
                dictName:'',//选项名称
                status:'',//状态
            },
            dialogEditTitle:'',//弹出层名字
            editType: void 0 // 编辑新增类型
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        },
    },
    vuerify: {
        'sendInfo.dictName':{
            test:function(val){
                if(val){
                    return true;
                }else{
                    return false;
                }
            },
            message:'输入选项名称'
        },
        'sendInfo.status':{
            test:function(val){
                if(val){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择状态'
        }
    },
    methods:{
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        //切换选项卡
        changeTab:function(num,name,id){
            this.tab=num;
            this.tabText=name;
            this.sendInfoOne.parentId=id;
            this.sendInfo.parentId=id;
            this.sendInfoOne.currentPage=1;//当前页
            this.sendInfoOne.pageSize=20;//当前页条数
            this.tableData=[];
            this.editType = void 0
            this.getData();
        },

        //上移
        moveTop:function(row){
			if(row.status==0){
				this.$message({
				  message: '还未启用，不能操作!',
				  type: 'warning'
				});
				return;
			}
			this.$axiosz.put('/backstage/sysDict/sort/'+row.id+'/sort/0').then((r)=>{
			    if(r.code==200){
			        this.$message({
			            type: 'success',
			            message:r.msg
			        });
			        this.getData();
			    }else{
			        this.$alert(r.msg);
			    }
			})
        },
        //下移
        moveDown:function(row){
			if(row.status==0){
				this.$message({
				  message: '还未启用，不能操作!',
				  type: 'warning'
				});
				return;
			}
			this.$axiosz.put('/backstage/sysDict/sort/'+row.id+'/sort/1').then((r)=>{
				if(r.code==200){
					this.$message({
						type: 'success',
						message:r.msg
					});
					this.getData();
				}else{
					this.$alert(r.msg);
				}
			})
        },
        //启用v禁用
        sold:function(row){
            this.$confirm('是否'+row.statusButtonName+'？', row.statusButtonName, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axiosz.put('backstage/sysDict/status/'+row.id).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                type: 'success',
                                message: row.statusButtonName+'成功!'
                            });
                            this.getData();
                        }else{
                            this.$alert(r.msg);
                        }
                    })
            }).catch(() => {});
        },


        //编辑
        edit:function(row){
            this.$vuerify.clear();
            this.editType = 1
            if(row){ //编辑
                // this.dialogEdit=true;
                // this.dialogEditTitle='编辑选项';
                this.sendInfo.id=row.id;
                this.sendInfo.dictName=row.dictName;
                this.sendInfo.status=row.status+'';
            }else{ //添加
                // this.dialogEdit=true;
                // this.dialogEditTitle='添加选项';
            }
        },
        //取消
        cancel:function(){
            this.editType = void 0;
            this.dialogEdit=false;
            this.sendInfo.dictName='';
            this.sendInfo.status='';
            this.sendInfo.id='';//自身id
        },
        //提交
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                if(this.sendInfo.id){ //修改
                    this.$axiosz.put('backstage/sysDict/'+this.sendInfo.id,this.$qs.stringify(this.sendInfo)).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            });
                            this.cancel();
                            this.getData();
                        }else{
                            this.$alert(r.msg);
                        }
                    })
                }else{ //添加
                    this.$axiosz.post('backstage/sysDict',this.$qs.stringify(this.sendInfo)).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                type: 'success',
                                message: '添加成功!'
                            });
                            this.cancel();
                            this.getData();
                        }else{
                            this.$alert(r.msg);
                        }
                    })
                }
            }
        },
        


        //获取字典
        getDic:function(){
            this.$axiosz.get('backstage/sysDict/STATUS').then((r)=>{ //状态数组
                if(r.code==200){
                    this.statusList=r.data;
                }
            })
        },
        //获取左边父级列表
        getParent:function(){
            this.$axiosz.get('backstage/sysDict').then((r)=>{
                if(r.code==200){
                    this.leftList=r.data;
                    this.sendInfoOne.parentId=r.data[0].id;
                    this.sendInfo.parentId=r.data[0].id;
                    this.getData();
                }else{
                    this.$alert(r.msg);
                }
            })
        },
        //获取列表
        getData:function(){
            const that = this
            that.loading = true
            that.$axiosz.get('backstage/sysDict/parentId',{params:that.sendInfoOne}).then((r)=>{
                that.loading = false
                if(r.code==200){
                    that.tableData=r.data.content;
                    that.totalSize=r.data.totalElements;
                    that.totalPage = r.data.totalPage;
                    that.sendInfoOne.currentPage = r.data.currentPage; //当前页
                }else{
                    that.$alert(r.msg);
                }
            }).catch(e=>{
                that.loading = false
            })
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
    },
    created(){
      	let leftList=this.leftList;
		for (let i in leftList) {
			if(leftList[i].permissionName=='系统配置'){
				let list=leftList[i].sysPermissionVoList;//前端配置
				for(let j in list){
					if(list[j].permissionName=='前端配置'){
						let volist=list[j].sysPermissionVoList;
						this.volist=volist;
						this.iData=volist[0].sysPermissionVoList;
						this.firstPath=volist[0].href;
					}
				}
			}
		}
    },
    mounted(){
      const that = this
	
        that.getDic();
        that.getParent();
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 30
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 30
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    }
}
</script>

<style lang="scss" scoped>
.warp{
    height:calc(100% - 40px);
    overflow: hidden;
    .box{
        display: flex;
        height: 100%;
        .leftBox{
            width:220px;
            margin-right: 20px;
            overflow-x: hidden;
            overflow-y: auto;
            li{
                width: 220px;
                height: 50px;
                line-height: 50px;
                text-align: center;
                color: #595959;
                font-size: 14px;
                cursor: pointer;
                &:not(:last-child){
                    border-bottom: none;
                }
                &.active{
                    color: #1069DD;
                    background: #F2FBFF;
                }
            }
        }
        .rightBox{
            flex: 1;
            width:calc(100% - 240px);
            
        }
        .forms{
            max-width: 610px;
            margin: auto;
            transform: translateX(-100px);
            padding-top:40px;
            .child{
                .name{
                  width:80px;
                  text-align: right;
                  margin-right:10px;
                }
                .content{
                    flex: 1;
					/deep/ .ql-container{
						min-height: 410px;
					}
                }
            }
        }
    }
}
</style>